export default __webpack_public_path__ + "static/media/illustration-algowork-m@2x.124a697b.png";